module.exports = __webpack_public_path__ + "img/D.d2eb6078.webp";